import { render, staticRenderFns } from "./BookingBranchShiftForm.vue?vue&type=template&id=24194863&"
import script from "./BookingBranchShiftForm.vue?vue&type=script&lang=js&"
export * from "./BookingBranchShiftForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports